/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { requestResetValidation } from 'validation/auth.validation';
import MobileContext from 'context/MobileContext';
import SignUpLayout from 'layouts/SignUpLayoutNew';
import Text from 'components/shared/Text';
import history from 'store/history';
import styles from './style.module.css';
import CustomTextField from '../CustomComponents/TextField';
import CustomButton from '../CustomComponents/Button';

const MagicLinkRequest = ({
  requestMagicLink,
  isMagicLinkRequesting,
  magicLinkData,
  clearMagicLinkData,
  error,
  requestType,
}) => {
  const [showError, setShowError] = useState(false);
  const isMobile = useContext(MobileContext);
  const mobClassName = isMobile ? styles.mob : '';

  // Clear magic link data when component mounts
  useEffect(() => {
    clearMagicLinkData();

    // Clear magic link data when component unmounts
    return () => {
      clearMagicLinkData();
    };
  }, [clearMagicLinkData]);

  useEffect(() => {
    if (requestType === 'CREATE_MAGIC_LINK_FAILURE' && error) {
      setShowError(true);
    }
  }, [requestType, error]);

  const handleBackClick = () => {
    history.push('/login');
  };

  return (
    <SignUpLayout
      width={isMobile ? '100%' : '550px'}
      height={
        isMobile ? '100%' : Object.keys(magicLinkData).length > 0 ? '350px' : '450px'
      }
      isMobile={isMobile}
      headerName={'Send One-Time Login Link'}
    >
      {Object.keys(magicLinkData).length > 0 ? (
        <div className={styles.successMessage}>
          Please check your <span className={styles.boldEmail}>email</span>.<br /> We sent
          you a One-Time Login link.
          <p
            className={`${styles.link}`}
            style={{ marginTop: '20px' }}
            onClick={handleBackClick}
          >
            Back to Login
          </p>
        </div>
      ) : (
        <div className={styles.page}>
          <Text tag="p" type="p2" className={`${styles.paragraph} ${mobClassName}`}>
            Enter the email address that&apos;s associated <br /> with your
            <strong className={`${styles.bold} ${mobClassName}`}>
              {' '}
              FITNESS SF account.
            </strong>
          </Text>

          <Text tag="p" type="p2" className={`${styles.p2} ${mobClassName}`}>
            We will send you a One-Time Login link.
          </Text>

          <Formik
            initialValues={{ email: '' }}
            validationSchema={requestResetValidation}
            onSubmit={({ email }) => {
              requestMagicLink(email?.toLowerCase());
            }}
          >
            {({
              handleSubmit,
              values,
              errors,
              touched,
              dirty,
              isValid,
              handleBlur,
              handleChange,
            }) => (
              <form className={styles.form} onSubmit={handleSubmit}>
                <CustomTextField
                  onChange={e => {
                    setShowError(false);
                    handleChange(e);
                  }}
                  value={values.email}
                  invalid={showError ? true : touched.email && Boolean(errors.email)}
                  error={showError ? error : errors.email}
                  name="email"
                  placeholder="Email address"
                  disabled={isMagicLinkRequesting}
                  onBlur={handleBlur}
                  marginTop={isMobile ? '20px' : '40px'}
                />
                <CustomButton
                  type="submit"
                  isRequesting={isMagicLinkRequesting}
                  disabled={!(isValid && dirty) || isMagicLinkRequesting}
                  className={`${styles.button} ${isMobile ? styles.mob : ''}`}
                >
                  Send
                </CustomButton>
                <p className={`${styles.link}`} onClick={handleBackClick}>
                  Back to Login
                </p>
              </form>
            )}
          </Formik>
        </div>
      )}
    </SignUpLayout>
  );
};

MagicLinkRequest.propTypes = {
  requestMagicLink: PropTypes.func.isRequired,
  clearMagicLinkData: PropTypes.func.isRequired,
  isMagicLinkRequesting: PropTypes.bool,
  magicLinkData: PropTypes.object,
  error: PropTypes.string,
  requestType: PropTypes.string,
};

MagicLinkRequest.defaultProps = {
  isMagicLinkRequesting: false,
  magicLinkData: {},
  error: '',
  requestType: '',
};

export default MagicLinkRequest;
